module.exports = __webpack_public_path__ + "media/fahrrad-filter/heldende-2f86b643.jpg";